/* Deskora FX: aparición al hacer scroll, tilt 3D, luz que sigue al cursor y comparador antes/después */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  function reveal() {
    var targets = document.querySelectorAll('main .shopify-section > *:not(.dk-noreveal), .product-grid > li, .dk-spot__row');
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dk-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el, i) {
      if (el.closest('.dk-stage')) return;
      el.classList.add('dk-reveal');
      el.style.setProperty('--dk-delay', (i % 4) * 70 + 'ms');
      io.observe(el);
    });
  }

  function tilt() {
    if (reduce || !fine) return;
    document.querySelectorAll('.card-wrapper .card, .dk-gal__stage').forEach(function (el) {
      el.classList.add('dk-tilt');
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
        el.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg');
        el.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
      });
    });
  }

  function cursorGlow() {
    if (reduce || !fine) return;
    var g = document.createElement('div');
    g.className = 'dk-cursor-glow'; g.setAttribute('aria-hidden', 'true');
    document.body.appendChild(g);
    var tx = 0, ty = 0, x = 0, y = 0, raf;
    window.addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY; g.classList.add('is-on');
      if (!raf) raf = requestAnimationFrame(step);
    });
    function step() {
      x += (tx - x) * 0.18; y += (ty - y) * 0.18;
      g.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      raf = Math.abs(tx - x) + Math.abs(ty - y) > 0.5 ? requestAnimationFrame(step) : null;
    }
  }

  function compare() {
    document.querySelectorAll('.dk-compare__frame').forEach(function (f) {
      var input = f.querySelector('input[type=range]');
      var set = function (v) { f.style.setProperty('--pos', v + '%'); };
      input.addEventListener('input', function () { set(input.value); });
      set(input.value);
    });
  }

  function galleries() {
    document.querySelectorAll('[data-dk-gal]').forEach(function (g) {
      var imgs = [].slice.call(g.querySelectorAll('.dk-gal__img'));
      var thumbs = [].slice.call(g.querySelectorAll('.dk-gal__thumb'));
      var count = g.querySelector('.dk-gal__count b');
      if (imgs.length < 2) { if (imgs[0]) imgs[0].classList.add('is-on'); return; }
      var i = 0;
      function show(n) {
        i = (n + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); if (k === i) im.loading = 'eager'; });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        if (count) count.textContent = i + 1;
        var t = thumbs[i]; if (t && t.parentNode.scrollTo) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
      }
      show(0);
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.dataset.n); });
        if (fine) t.addEventListener('mouseenter', function () { show(+t.dataset.n); });
      });
      g.querySelectorAll('.dk-gal__arrow').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); show(i + +b.dataset.dir); });
      });
      var main = g.querySelector('.dk-gal__main'), sx = null, moved = false;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; moved = false; }, { passive: true });
      main.addEventListener('touchmove', function (e) { if (sx !== null && Math.abs(e.touches[0].clientX - sx) > 10) moved = true; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return; var d = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(d) > 40) show(i + (d < 0 ? 1 : -1));
      });
      main.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } });
    });
  }

  function init() { reveal(); compare(); galleries(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
